// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"699":"6a587bbf","939":"aa301f9b","944":"6b455ed5","983":"d77d3f5b"}[chunkId] + ".chunk.js";
};